import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { Badge } from "@mui/material";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "src/features/authSlice";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "src/store";
import { getUserDisplayName, getUserAvatar } from "src/features/authSlice";
import { useTranslation } from "react-i18next";

const Header = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const { t } = useTranslation();
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    void dispatch(logoutUser());
    handleCloseUserMenu();
    navigate("/login");
  };

  const handleProfileClick = () => {
    handleCloseUserMenu();
    navigate("/settings?tab=profile");
  };

  const settings = [
    { key: "profile", label: t("header.profile"), action: handleProfileClick },
    { key: "account", label: t("header.account"), action: handleCloseUserMenu },
    { key: "dashboard", label: t("header.dashboard"), action: handleCloseUserMenu },
    { key: "logout", label: t("header.logout"), action: handleLogout },
  ];

  return (
    <AppBar position="fixed" color="default" sx={{ boxShadow: 3, zIndex: 304 }}>
      <Container maxWidth="xxl">
        <Toolbar disableGutters>
          <IconButton onClick={() => setOpen(!open)}>
            <MenuIcon />
          </IconButton>

          <Box sx={{ flexGrow: 1 }}>
            <img
              src={"/logo.png"}
              alt="Logo"
              style={{ height: 80, marginLeft: 16 }}
            />
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Badge badgeContent={4} color="primary">
              <MailOutlinedIcon />
            </Badge>
            <Tooltip title={t("header.openSettings")}>
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0, ml: 3 }}>
                <Avatar
                  alt={getUserDisplayName(user)}
                  src={getUserAvatar(user)}
                  sx={{ bgcolor: "#8d99ff" }}
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting.key} onClick={setting.action}>
                  <Typography textAlign="center">{setting.label}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
